import { useEffect, useRef, useState } from "react";
import api from "../../lib/api";
import { Input } from "../ui/input";
import { Search, UserCheck } from "lucide-react";

const label = (r) => `${r.nome} ${r.cognome}`.trim();
const fullName = (r) => label(r).toUpperCase();
const roleLabel = (r) => {
  const f = (r.fonte || "").toLowerCase();
  const extra = f === "lato controparte" && !/controparte/i.test(r.ruolo) ? " (controparte)" : f === "soggetto secondario" ? " (secondario)" : "";
  return `${r.ruolo || ""}${extra}`;
};

export default function RecipientPicker({ praticaId, onPick }) {
  const [soggetti, setSoggetti] = useState([]);
  const [q, setQ] = useState("");
  const [res, setRes] = useState([]);
  const [openRes, setOpenRes] = useState(false);
  const tm = useRef(null);
  useEffect(() => { api.get(`/studio/pratiche/${praticaId}/condivisioni/soggetti`).then(({ data }) => setSoggetti(data)).catch(() => setSoggetti([])); }, [praticaId]);
  useEffect(() => {
    clearTimeout(tm.current);
    if (q.trim().length < 2) { setRes([]); return undefined; }
    tm.current = setTimeout(() => api.get("/studio/condivisioni/cerca-destinatari", { params: { q } }).then(({ data }) => { setRes(data); setOpenRes(true); }).catch(() => setRes([])), 250);
    return () => clearTimeout(tm.current);
  }, [q]);
  const pick = (r) => { onPick(r); setQ(""); setRes([]); setOpenRes(false); };
  return (
    <div className="space-y-3" data-testid="share-recipient-picker">
      {soggetti.length > 0 && (
        <div>
          <div className="text-xs uppercase tracking-wide text-slate-400 mb-1.5">Soggetti della pratica</div>
          <div className="flex flex-wrap gap-1.5 max-h-40 overflow-y-auto">
            {soggetti.map((r, i) => (
              <button type="button" key={`${label(r)}-${r.ruolo}-${i}`} onClick={() => pick(r)} data-testid={`share-soggetto-${i}`} title={`${fullName(r)} · ${roleLabel(r)}${r.email ? ` — ${r.email}` : " — Email non presente in anagrafica"}`}
                className="inline-flex items-center gap-1 rounded-full border border-slate-700 bg-slate-800/50 px-2.5 py-1 text-xs text-slate-200 hover:border-amber-500/60 hover:bg-amber-500/10 transition-colors text-left">
                <UserCheck className="h-3 w-3 text-amber-400 shrink-0" /><span className="font-semibold whitespace-nowrap" data-testid={`share-soggetto-nome-${i}`}>{fullName(r)}</span><span className="text-slate-400 whitespace-nowrap" data-testid={`share-soggetto-ruolo-${i}`}>· {roleLabel(r)}</span>
              </button>
            ))}
          </div>
        </div>
      )}
      <div className="relative">
        <Search className="absolute left-2.5 top-1/2 -translate-y-1/2 h-3.5 w-3.5 text-slate-500" />
        <Input value={q} onChange={(e) => setQ(e.target.value)} onFocus={() => res.length && setOpenRes(true)} onBlur={() => setTimeout(() => setOpenRes(false), 150)}
          placeholder="Cerca nelle anagrafiche dello studio…" data-testid="share-search-anag" className="pl-8 h-9 bg-slate-900/60 border-slate-700 text-sm" />
        {openRes && (
          <div className="absolute z-50 mt-1 w-full max-h-56 overflow-y-auto rounded-md border border-[#cbd5e1] bg-[#ffffff] shadow-xl" data-testid="share-search-results">
            {res.length === 0 && <div className="px-3 py-2 text-xs text-[#64748b]">Nessun risultato</div>}
            {res.map((r, i) => (
              <button type="button" key={i} onMouseDown={(e) => { e.preventDefault(); pick(r); }} data-testid={`share-search-result-${i}`}
                className="w-full text-left px-3 py-2 hover:bg-[#f1f5f9] border-b border-[#e2e8f0] last:border-0">
                <div className="text-sm text-[#0f172a]">{label(r)} <span className="text-xs text-[#b45309]">{r.ruolo}</span></div>
                <div className="text-xs text-[#64748b] break-all">{r.email || "nessuna email"}</div>
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
